/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";
import Skeleton from "react-loading-skeleton";
import moment from "moment";
// import SelectInput2 from "../../../component/input/SelectInput2";
// import Button from "../../../component/button/Button";

const ReimbursementList = ({
  hrLoading,
  allReimbursement,
  changeSelectedStatus,
  onChangeReimbursementStatus
}) => {
  if (hrLoading) {
    return (
      <tr>
        <td>
          <Skeleton count={1} />
        </td>
        <td>
          <Skeleton count={1} />
        </td>
        <td>
          <Skeleton count={1} />
        </td>
        <td>
          <Skeleton count={1} />
        </td>
        <td>
          <Skeleton count={1} />
        </td>
        <td>
          <Skeleton count={1} />
        </td>
        <td>
          <Skeleton count={1} />
        </td>
        <td>
          <Skeleton count={1} />
        </td>
        <td>
          <Skeleton count={1} />
        </td>
        <td>
          <Skeleton count={1} />
        </td>
        <td>
          <Skeleton count={1} />
        </td>
        <td>
          <Skeleton count={1} />
        </td>
        <td>
          <Skeleton count={1} />
        </td>
      </tr>
    );
  } else if (allReimbursement.length === 0) {
    return (
      <tr style={{ top: "50%", left: "50%", position: "fixed" }}>
        <td>
          <span className=""> No Record Found</span>
        </td>
      </tr>
    );
  } else if (
    typeof allReimbursement !== "undefined" &&
    allReimbursement !== null &&
    allReimbursement.length > 0
  ) {
    return allReimbursement.map((detailReimbursement, index) => (
      <tr
        key={index}
        data-toggle="modal"
        data-target={`#reimbursement_modal_${index}`}
        style={{ fontSize: "12px" }}
      >
        <td>
          <span className="">{index + 1}</span>
        </td>
        <td>
          <span className="">
            {moment(detailReimbursement?.fromDate).format(
              "DD-MM-YYYY"
            )}
          </span>
        </td>
        <td>
          <span className="">
            {moment(detailReimbursement?.toDate).format("DD-MM-YYYY")}
          </span>
        </td>
        <td className="text-center">
          <span className="">{detailReimbursement?.workerId}</span>
        </td>
        <td className="text-center">
          <span className="">
            {detailReimbursement?.employeeFullName || "-"}
          </span>
        </td>

        <td className="text-center">
          <span className="">
            {detailReimbursement?.reimbursementType}
          </span>
        </td>
        <td className="text-center">
          <span className="">
            {moment(detailReimbursement?.createdAt).format(
              "DD-MM-YYYY"
            )}
          </span>
        </td>
        <td className="text-center">
          <span className="">{detailReimbursement.reason}</span>
        </td>
        <td className="text-center">
          <span className="">{detailReimbursement.amount}</span>
        </td>
        <td className="text-center">
          <span className="">
            <a
              href={detailReimbursement.photoCopy}
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="mdi mdi-cloud-download">Download</i>
            </a>
          </span>
        </td>
        <td className="text-center">
          <span
            className={
              detailReimbursement.status === "Pending"
                ? "badge badge-info text-white"
                : detailReimbursement.status === "Approved"
                ? "badge badge-success text-white"
                : detailReimbursement.status === "Rejected"
                ? "badge badge-danger text-white"
                : detailReimbursement.status === "Hold"
                ? "badge badge-warning text-white"
                : "badge badge-success text-white"
            }
          >
            {detailReimbursement?.status}
          </span>
        </td>
        <td className="text-center">
          <span className="">
            <select
              value={detailReimbursement.status}
              onChange={(e) =>
                changeSelectedStatus(e, detailReimbursement._id)
              }
              placeholder="Select Status"
            >
              <option value="Pending">Pending</option>
              <option value="Hold">Hold</option>
              <option value="Rejected">Rejected</option>
              <option value="Approved">Approved</option>
            </select>
          </span>
        </td>
        <td className="text-center">
          <span className="">
            <button
              onClick={() =>
                onChangeReimbursementStatus(detailReimbursement)
              }
            >
              Submit
            </button>
          </span>
        </td>
      </tr>
    ));
  }
};

ReimbursementList.propTypes = {
  hrLoading: PropTypes.bool.isRequired,
  allReimbursement: PropTypes.array.isRequired,
  changeSelectedStatus: PropTypes.func.isRequired,
  onChangeReimbursementStatus: PropTypes.func.isRequired
};

export default ReimbursementList;
